import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Layout rỗng — chỉ để gom 2 route con (trang chính + trang hồ sơ 1 người)
 * dưới cùng tiền tố URL /se-duyen. Nội dung thật nằm ở se-duyen.index.tsx
 * (trang chính) và se-duyen.$handle.tsx (trang hồ sơ 1 người). */
export const Route = createFileRoute("/_authenticated/se-duyen")({
  component: () => <Outlet />,
});
